export default __webpack_public_path__ + "static/media/Ellipse30Track1.483a22c5.svg";